import { IUseProductReviewReturn } from '@monofront/business/hooks';
import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

interface IProductPageContextProps {
  sku?: string;
  setSku: Dispatch<SetStateAction<string | undefined>>;
  useGetProductReviewsHook?: IUseProductReviewReturn;
  isProductPage: boolean;
}

const ProductPageContext = createContext<IProductPageContextProps>({
  sku: undefined,
  setSku: () => undefined,
  useGetProductReviewsHook: undefined,
  isProductPage: false,
});

const ProductPageContextProvider: React.FC<{
  children: React.ReactNode;
  useGetProductReviewsHook: IUseProductReviewReturn;
}> = ({ children, useGetProductReviewsHook }) => {
  const [sku, setSku] = useState<string | undefined>();

  return (
    <ProductPageContext.Provider
      value={{
        sku,
        setSku,
        useGetProductReviewsHook,
        isProductPage: true,
      }}
    >
      {children}
    </ProductPageContext.Provider>
  );
};

const useProductPageContext = () => useContext(ProductPageContext);

export { ProductPageContextProvider, useProductPageContext };
